<template>
    <div class="app"
        id="app">
        <CookieBar
            v-if="!preferences.cookies"
            @setAnalyticsCookies="setAnalyticsCookies"/>
        <Landing v-if="!auth.id && landing && $route.name === 'home'"
            @changeView="landing=false"/>
        <Application v-else/>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'

    import Application from '@/components/application/Application'
    import Landing     from '@/components/landing/Landing'
    import CookieBar   from '@/components/templates/CookieBar'

    export default {
        name: 'App',
        components: {
            CookieBar,
            Landing,
            Application
        },
        data() {
            return {
                landing: true
            }
        },
        mounted() {
            this.setScheme()
            this.setTheme()
            this.setLanguage()
            
            if(this.preferences.cookies === 'all') {
                this.setAnalyticsCookies()
            }

            document.addEventListener('keydown', this.changeLanguageWithKeyPress)
        },
        destroyed() {
            document.removeEventListener('keydown', this.changeLanguageWithKeyPress)
        },
        created() {
            const html = document.documentElement
            if(this.preferences.language === 'hu') {
                html.setAttribute('lang', 'hu')
            }
        },
        methods: {
            ...mapActions('users',['setPreferredLanguage']),

            setLanguage() {
                if(window.navigator.language.slice(0, 2) === 'hu') {
                    this.setPreferredLanguage('hu')
                }
            },

            setTheme() {
                if(this.preferences.theme === 'dark') {
                    document.documentElement.setAttribute('data-theme', 'dark')
                } else {
                    document.documentElement.setAttribute('data-theme', 'light')
                }
            },

            setAnalyticsCookies() {
                this.setAnalytics()
                this.setHotjar()
            },

            setAnalytics() {
                let Script = document.createElement("script")
                Script.setAttribute("src", "https://www.googletagmanager.com/gtag/js?id=UA-145378881-1")
                document.head.appendChild(Script)

                window.dataLayer = window.dataLayer || []
                function gtag(){dataLayer.push(arguments)}
                gtag('js', new Date())

                gtag('config', 'UA-145378881-1')
            },

            setHotjar() {
                (function(h,o,t,j,a,r){
                    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                    h._hjSettings={hjid:1438479,hjsv:6};
                    a=o.getElementsByTagName('head')[0];
                    r=o.createElement('script');r.async=1;
                    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                    a.appendChild(r);
                })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
            },

            setScheme() {
                var root = document.querySelector(':root')
                var primaryColor
                var primaryAscent
                var primaryDescent
                var color = this.preferences.scheme

                if(color === 'avocado') {
                    primaryColor = '#70ff90'
                    primaryAscent = '#88f7a2'
                    primaryDescent = '#46c262'
                } else if(color === 'orange') {
                    primaryColor = '#fa732a'
                    primaryAscent = '#ff8542'
                    primaryDescent = '#cf5411'
                } else if(color === 'strawberry') {
                    primaryColor = '#ed2b45'
                    primaryAscent = '#f55369'
                    primaryDescent = '#bd132a'
                } else {
                    primaryColor = '#ffbf00'
                    primaryAscent = '#ffda6c'
                    primaryDescent = '#db9600'
                }
                root.style.setProperty('--color-primary-500', primaryColor)
                root.style.setProperty('--color-primary-300', primaryDescent)
                root.style.setProperty('--color-primary-700', primaryAscent)
            },

            changeLanguageWithKeyPress(e) {
                if(document.activeElement.tagName === 'BODY') {
                    if(e.key === 'H' && !e.getModifierState('CapsLock') && this.preferences.language !== 'hu') {
                        this.setPreferredLanguage('hu')
                        this.$toasted.show(this.siteContent.updatedLanguagePreference)
                    } else if(e.key === 'E' && !e.getModifierState('CapsLock') && this.preferences.language !== 'en') {
                        this.setPreferredLanguage('en')
                        this.$toasted.show(this.siteContent.updatedLanguagePreference)
                    }
                } else {
                    return
                }

                const html = document.documentElement
                if(this.preferences.language === 'hu') {
                    html.setAttribute('lang', 'hu')
                } else {
                    html.setAttribute('lang', 'en')
                }
            }
        },
        metaInfo() {
            if(this.preferences.language === 'hu') {
                return {
                    title: `${'Creatillo'}`,
                    link: [
                        { rel: 'canonical', href: 'https://creatillo.com' + this.$route.fullPath }
                    ],
                    meta: [
                        { vmid: 'description', name: 'description', content: 'A platform, amilyennek szeretted volna az Instagramot.' },
                        { vmid: 'keywords', name: 'keywords', content: 'instagram, media sharing, platform, image sharing, app' }
                    ]
                }
            } else {
                return {
                    title: `${'Creatillo'}`,
                    link: [
                        { rel: 'canonical', href: 'https://creatillo.com' + this.$route.fullPath }
                    ],
                    meta: [
                        { vmid: 'description', name: 'description', content: 'The platform you expected of Instagram to become.' },
                        { vmid: 'keywords', name: 'keywords', content: 'instagram, media sharing, platform, image sharing, app' }
                    ]
                }
            }
        }
    }
</script>

<style lang="scss">
    @import 'scss/variables';
    @import 'scss/global';
    @import 'scss/toasted';

    .app {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        min-height: 100vh;
    }
</style>